export enum PrintBarcodeDirection {
  LEFT_TO_RIGHT = 'LEFT_TO_RIGHT',
  BOTTOM_TO_TOP = 'BOTTOM_TO_TOP',
  RIGHT_TO_LEFT = 'RIGHT_TO_LEFT',
  TOP_TO_BOTTOM = 'TOP_TO_BOTTOM',
}
